<script setup>
import { h, isVNode, computed } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
  class: { type: String, default: '' },
});

const iconClasses = computed(() => {
  const baseClasses = props.icon;
  const additionalClasses = props.class;

  if (typeof baseClasses === 'string') {
    return `${baseClasses} ${additionalClasses}`.trim();
  }

  return baseClasses;
});

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  return h('span', { class: iconClasses.value });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
